import { GetVenueContextResponseBody } from '../types/generated/venueContext_get.response';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestVenueContext = (
  token: string
): Promise<GetVenueContextResponseBody> =>
  fetcher<GetVenueContextResponseBody>(
    apiEndpoints.routes.venueContext,
    'GET',
    token
  );
